module.exports = __webpack_public_path__ + "static/media/ripley-crossmod-kitchendetails-stainless-steel-sink.d6b2aa74.jpg";